import { IApiInterface } from "@gwn/guac-lib";

const delay = async (s) => new Promise((r) => setTimeout(r, s));

const response = async (methodName) => {
  await delay(400);
  const date = new Date();
  return {
    method: methodName,
    date: date.toISOString(),
  };
};

export const apiInterface: IApiInterface = {
  get: async () => response("GET"),
  post: async () => response("POST"),
  put: async () => response("PUT"),
  delete: async () => response("DELETE"),
};
